// hooks/useLanguageDirection.js
import { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";

const rtlLanguages = ['ar', 'he', 'fa', 'ur']; 

export function useLanguageDirection(updateHtmlDir = true) {
  const { i18n } = useTranslation();

  // Determine if current language is RTL
  const isRtl = useMemo(() => rtlLanguages.includes(i18n.language), [i18n.language]);

  // Optionally update <html> dir attribute
  useEffect(() => {
    if (updateHtmlDir) {
      document.documentElement.dir = isRtl ? "rtl" : "ltr";
    }
  }, [isRtl, updateHtmlDir]);

  return { isRtl, direction: isRtl ? "rtl" : "ltr", language: i18n.language };
}
